import React from 'react';

import Loading from '../../Loading';
import useBubbleData from './useBubbleData';
import BubbleView from './BubbleView';

const BubbleContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData, isReady } = useBubbleData({
    chartDefinition,
    chartRef,
  });

  if (!isReady) {
    return <Loading />;
  }

  return (
    <BubbleView
      chartRef={chartRef}
      options={options ?? {}}
      isNoData={isNoData || !options}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default BubbleContent;
